import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  exp: number;
  iat?: number;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'?: string | string[];
  [key: string]: any;
}

class JwtHelper {
  static getRoles(token: string): string[] {
    if (!token) return [];

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const roleData = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

      if (Array.isArray(roleData)) return roleData;
      if (typeof roleData === 'string') return [roleData];
      return [];
    } catch (err) {
      return [];
    }
  }

  static isTokenExpired(token: string): boolean {
    if (!token) return true;

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decodedToken.exp < currentTime;
    } catch (err) {
      return true;
    }
  }
}

export default JwtHelper;
